import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IDescription} from "../../../../../../utils/interfaces/service/description/IDescription";


const useApiUpdateDescription = (): UseMutationResult<IDescription, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IDescription> {
        try {
            const response = await put(`/api/company/${company_token}/service/description/${pk}`, data);
            return response.data as IDescription;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IDescription, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetDescription', data.id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetDescriptions', data.scope]});
        },
    });
};


export default useApiUpdateDescription;